import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VTooltip from 'v-tooltip'
import VueToasted from 'vue-toasted'
import VueI18n from 'vue-i18n';

Vue.use(VTooltip)
Vue.use(VueToasted)
Vue.use(VueI18n);

const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en_US'
const i18n = new VueI18n({
    locale: lang,
    messages: {
        ja_JP: require('@/lang/ja_JP.json'),
        en_US: require('@/lang/en_US.json'),
        zh_CN: require('@/lang/zh_CN.json')
    }
});

Vue.config.productionTip = false

// Making the truncate filter global.
Vue.filter('truncate', function (longString, maxLength) {
  if(longString.length > maxLength){
      const trimmedString = longString.substr(0, maxLength);
      // re-trim if we are in the middle of a word
      const wordTrim = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))
      if(wordTrim.length === 0) {
        return trimmedString  + '…'
      }
      else {
        return wordTrim  + '…'
      }
  }
  return longString;
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
